<template>
  <b-modal ref="modal" size="md" lazy no-close-on-backdrop hide-header-close>
    <template slot="modal-header">
      <h2>{{ $t("project.createNewProject") }}</h2>
    </template>
    <template slot="default">
      <div v-if="!loading">
        <b-form novalidate>
          <b-container>
            <b-form-group :label="$t('project.name')" class="text-left">
              <b-form-input
                  type="text"
                  v-validate="'required'"
                  :data-vv-as="$t('project.name')"
                  data-vv-name="projectname"
                  v-model="projectInfo.name"
                  autofocus
                  maxlength="50"
                  :class="{ 'is-invalid': errors.has('projectname') }"
                  @keydown.enter.prevent="onSubmitClick"
              />
              <span class="invalid-feedback">{{
                  errors.first("projectname")
                }}</span>
            </b-form-group>
            <b-form-group :label="$t('project.description')" class="text-left">
              <b-form-textarea
                  v-model="projectInfo.description"
                  rows="3"
                  maxlength="500"
              />
            </b-form-group>
          </b-container>
        </b-form>
      </div>
      <div v-else class="text-center">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </template>
    <template slot="modal-footer">
      <b-button @click="onCancelClick">{{ $t("cancel") }}</b-button>
      <b-button @click="onSubmitClick" variant="primary">{{
          $t("create")
        }}</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      projectInfo: {
        name: "",
        description: ""
      },
      loading: false
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showModal() {
      this.$refs.modal.show();
    },
    reset() {
      this.projectInfo = {
        name: "",
        description: ""
      }
    },
    onCancelClick() {
      this.loading = false;
      this.reset()
      this.$emit("cancel");
    },
    onSubmitClick: async function () {
      await this.$validator.validateAll().then(async result => {
        if (result) {
          this.loading = true;
          const project = await this.$store.dispatch("projects/createProject", this.projectInfo);
          this.$emit("submit", project);
          this.reset()
          this.loading = false;
          this.$refs.modal.hide();
        }
      });
    }
  },
  mounted() {
    if (this.show) this.showModal();
    var self = this;
    window.addEventListener("keyup", function (event) {
      if (event.key == "Esc") {
        self.onCancelClick();
      }
    });
  },
  watch: {
    show(val) {
      if (val) this.showModal();
      else {
        this.$refs.modal.hide();
      }
    }
  }
};
</script>
